import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AdminService } from '../../../services/admin/admin.service';

@Component({
  selector: 'app-admin-shell',
  templateUrl: './admin-shell.component.html',
  styleUrls: ['./admin-shell.component.scss']
})
export class AdminShellComponent implements OnInit {
  sidebarCollapsed = true;
  adminUser: any = null;
  pageTitle = 'Dashboard';
  currentTime = new Date();

  private titleMap: Record<string, string> = {
    '/admin/dashboard': 'Dashboard',
    '/admin/plans': 'Plan Manager',
    '/admin/users': 'User Management',
  };

  constructor(private adminService: AdminService, private router: Router) {}

  ngOnInit(): void {
    this.adminUser = this.adminService.getStoredAdmin();
    setInterval(() => this.currentTime = new Date(), 1000);
    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.pageTitle = this.titleMap[e.url] || 'Admin';
      }
    });
  }

  logout(): void {
    this.adminService.logout();
    this.router.navigate(['/admin/login']);
  }
  toggleSidebar(): void {
  this.sidebarCollapsed = !this.sidebarCollapsed;
}

closeMobileSidebar(): void {
  if (window.innerWidth <= 767) {
    this.sidebarCollapsed = true;
  }
}
}
